// Module
var code = `<select class="form-control" ng-options="lang for lang in langItems" name="langCode" ng-model="\$root.selectedLang" ng-change="changeLang()"> </select>`;
// Exports
export default code;